<template>
    <div>
        <div class="mb-3">
            <custom-radio v-model="classMenu" :items="mealsDesigner" type="list"/>
        </div>
        <div class="mb-3">
            <k-select
                v-if="totalQty > 5"
                v-model="mealQty"
                :placeholder="trans('general.module.report.update_popup.step.details.select_consumed_amount')"
                :inline-dropdown="true"
                :options="mealQuantities"
                :show-selected-options="false"
                auto-close="true"
                @search="loadMealQuantities"
            />

            <div v-if="totalQty <= 5">
                <div class="text-dark mb-2">
                    {{ trans('general.module.report.update_popup.step.details.select_consumed_amount') }}:
                </div>
                <div class="meals forms-check">
                    <div class="form-check form-check py-2 py-lg-1" v-for="qty in mealQuantities">
                        <input class="form-check-input" type="radio" name="meal_quantity_id"
                               v-model="mealQtyId"
                               :id="'qty-' + qty.id"
                               :value="qty.id">
                        <label class="form-check-label text-dark" :for="'qty-' + qty.id">{{ qty.label }}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomRadio from "../../../../theme/molecules/CustomRadio.vue";
import vSelect from "vue-select";
import GeneralReportForm from "../GeneralReportForm.vue";
import KSelect from "../../../../theme/molecules/KSelect.vue";
export default {
    name: "Meal",
    extends: GeneralReportForm,
    components: {KSelect, vSelect, CustomRadio},
    data() {
        return {
            model: {
                ...this.value,
                plan_id: null,
                meal_quantity_id: null,
                time: null,
            },

            classMenu: {value: ''},
            mealsDesigner: [],
            mealQty: [],
            totalQty: 0,
            mealQtyId: null,
            menus: [],
            mealQuantities: [],
        };
    },
    watch: {
        model: {
            handler: function (value) {
                this.internalUpdate = true;
                this.$emit('input', value);
            },
            deep: true
        },
        classMenu: function (value) {
            let selectedMealPlanner = this.mealsDesigner.find(item => item.value === this.classMenu.value).data;

            this.model.time = selectedMealPlanner.start;
            this.model.plan_id = value.value;
        },
        mealQtyId: function (value) {
            this.model.meal_quantity_id = value;
        },
        mealQty: function (value) {
            this.model.meal_quantity_id = value[0].id;
        },
    },
    methods: {
        loadClassMenu(search) {
            this.searchClassMenu(search, this)
        },
        searchClassMenu: _.debounce((search, vm) => {
            axios.get(`/child-report/class/${vm.classId}/today-menu`)
                .then((response) => {
                    vm.menus = response.data.data ?? [];

                    let items = [];
                    response.data.data.forEach((item) => {
                        items.push({
                            value: item.id,
                            cls: 'bg-light-blue',
                            text: `<strong>${item.title}</strong>${item.description ? '<div class="ms-3 ps-1 fw-normal">- ' + item.description.replace('|', '<br>- ') + '</div>' : ''}`,
                            color: 'text-dark-purple',
                            icon: 'fi-rr-utensils',
                            data: item,
                        });
                    });

                    vm.mealsDesigner = items;
                });
        }, 350),
        loadMealQuantities(search) {
            this.searchMealQuantities(search, this)
        },
        searchMealQuantities: _.debounce((search, vm) => {
            axios.get(`/settings/meal-quantity`, {
                params: {
                    limit: 15,
                    search,
                    search_fields: 'label:like',
                    order_by: 'label'
                }
            })
                .then((response) => {
                    let data = response.data;
                    vm.totalQty = data.data.total;
                    vm.mealQuantities = data.data.data.sort((a, b) => a.value - b.value);
                });
        }, 350),
    },
    mounted() {
        this.loadClassMenu('');
        this.loadMealQuantities('');
    }
};
</script>

<style scoped>
.meal-select .vs__selected-options {
    position: relative;
    width: 75% !important;
}

.meal-select .vs__selected {
    position: relative;
    width: 90% !important;
}

@media (min-width: 991px) {
    .meals.forms-check {
        display: flex;
        flex-wrap: wrap;
        gap: 5px 20px;
    }
}
</style>
